module.exports = __webpack_public_path__ + "docs/irtp-1.1.pdf";